import { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import {
  MandatoryExplanation,
  MandatoryFieldIndicator,
} from "../../helpers/constants/Constants";
import {
  addProject,
  fetchMviewRegions,
  getAllProjectUsers,
  getAllSurveys,
  getAssetFilters,
  getRegionStatuses,
} from "../../helpers/axios/projectsAxios";
import {
  ALL_ASSETS,
  ALL_PROJECT_USERS,
  ALL_SURVEYS,
  REGIONAL_STATUSES,
  SELECTED_PROJECT,
  updateGlobalState,
} from "../../helpers/reducers/GlobalReducer";
import {
  SELECTED_ICON,
  updateNavigationState,
} from "../../helpers/reducers/NavigationReducer";
import { getAllRegionAssets } from "../../helpers/axios/assetsAxios";

const ProjectSetupNew = () => {
  const { selectedProject, userDetails } = useSelector(
    (state) => state.globalReducer,
  );
  const [regions, setRegions] = useState([]);
  const [assetFilters, setAssetFilters] = useState([]);
  const [assetFilterLevels, setAssetFilterLevels] = useState([]);

  const [projectInput, setProjectInput] = useState({});

  const editRights = ["Design Manager", "Admin"]; //add roles here that we want to be able to edit the project setup

  const dispatch = useDispatch();
  const fetchRegions = async () => {
    const tempRegions = await fetchMviewRegions();
    setRegions(tempRegions.data);
  };

  //   const fetchProjectTypes = async (regionCode) => {
  //     const tempProjectTypes = await getProjectTypes(regionCode);
  //     setProjectTypes(tempProjectTypes.data);
  //   };

  //   const fetchSiteTypes = async (regionCode, projectType) => {
  //     const tempSiteTypes = await getSiteTypes(regionCode, projectType);
  //     setSiteTypes(tempSiteTypes.data);
  //   };

  const fetchRegionAssetFilters = async (regionCode, id, levelIndex) => {
    const assetFiltersTemp = await getAssetFilters(regionCode, id);
    const newAssetFilters = [
      ...assetFilters.filter((o) => o.levelIndex <= levelIndex),
      ...assetFiltersTemp?.data,
    ];
    const levels = [
      ...new Set(
        newAssetFilters
          .sort((a, b) => a.levelIndex - b.levelIndex)
          .map((filter) => filter.level),
      ),
    ];
    //Set the asset filter levels to be all the unique levels from the asset filters
    setAssetFilterLevels(levels);
    setAssetFilters(newAssetFilters);
  };

  const saveProjectSetup = async () => {
    const filters = Object.values(projectInput.assetFilters || {});
    const tempAssetFilters = filters.length
      ? filters.reduce((a, b) =>
          a.data.levelIndex > b.data.levelIndex ? a : b,
        ).value
      : null;

    const checkField = (field) => {
      return projectInput.region.data && projectInput.region.data[field]
        ? // ? selectedProject[0].mviewProjectInfo &&
          //     selectedProject[0].mviewProjectInfo[field]
          projectInput && projectInput[field]
        : true;
    };

    let tempProjectSetup = false;
    if (
      projectInput?.projectCode &&
      checkField("projectLocationCode") &&
      projectInput.region?.data?.code
    ) {
      tempProjectSetup = true;
    } else {
      tempProjectSetup = false;
    }
    const tempProject = {
      ...selectedProject[0],
      projectCode: projectInput?.projectCode || "",
      mviewProjectInfo: {
        ...selectedProject[0]?.mviewProjectInfo,
        projectCode: projectInput?.projectCode || "",
        regionCode: projectInput.region?.data?.code || "",
        projectLocationCode: projectInput?.projectLocationCode || null,
        assetFilters: projectInput?.assetFilters || null,
        assetFilterKey: tempAssetFilters,
        projectSetup: tempProjectSetup,
        region: projectInput.region?.data || null,
      },
    };

    // tempProject.projectCode = projectInput.projectCode;
    // tempProject.mviewProjectInfo.projectCode = projectInput.projectCode;
    // tempProject.mviewProjectInfo.regionCode = projectInput.region?.data.code;
    // tempProject.mviewProjectInfo.projectLocationCode =
    //   projectInput.projectLocationCode ?? null;
    // tempProject.mviewProjectInfo.assetFilters =
    //   projectInput.assetFilters || null;

    // const filters = Object.values(projectInput.assetFilters || {});
    // tempProject.mviewProjectInfo.assetFilterKey = filters.length
    //   ? filters.reduce((a, b) =>
    //       a.data.levelIndex > b.data.levelIndex ? a : b
    //     ).value
    //   : null;

    if (filters.length) {
      const highest = filters.reduce((a, b) =>
        a.data.levelIndex > b.data.levelIndex ? a : b,
      );
      if (highest.data.children?.length) {
        alert(
          "The highest level asset filter has children. Please select the lowest level filter without children.",
        );
        return;
      }
    }

    await addProject([tempProject]);
    Promise.all([
      await fetchStatuses(tempProject?.mviewProjectInfo?.regionCode),
      await fetchAssetData(
        tempProject?.mviewProjectInfo?.regionCode,
        tempProject?.mviewProjectInfo?.assetFilterKey,
      ),
      await fetchSurveys(tempProject?.mviewProjectInfo?.regionCode),
      await fetchAllProjectUsers(tempProject?.id),
      // await fetchProjectTypes(tempProject?.mviewProjectInfo?.regionCode),
      // await fetchSiteTypes(
      //   tempProject?.mviewProjectInfo?.regionCode,
      //   tempProjectType
      // ),
    ]);
    dispatch(
      updateGlobalState({
        value: [tempProject],
        stateName: SELECTED_PROJECT,
      }),
    );
    dispatch(
      updateNavigationState({
        value: "Project Config",
        stateName: SELECTED_ICON,
      }),
    );
    // Add logic to save the project input data
  };

  const fetchStatuses = async (regionCode) => {
    if (!regionCode) {
      dispatch(
        updateGlobalState({
          value: [],
          stateName: REGIONAL_STATUSES,
        }),
      );
      return;
    }
    const data = await getRegionStatuses(regionCode);
    dispatch(
      updateGlobalState({
        value: data,
        stateName: REGIONAL_STATUSES,
      }),
    );
  };

  const fetchAssetData = async (regionCode, assetFilterKey) => {
    if (!regionCode) {
      // console.warn("Region code or site type is not defined.");
      return;
    }
    const tempAssets = await getAllRegionAssets(regionCode, assetFilterKey);

    const sortedData = tempAssets.sort((a, b) => a.name.localeCompare(b.name));

    dispatch(
      updateGlobalState({
        value: sortedData,
        stateName: ALL_ASSETS,
      }),
    );
  };

  const fetchSurveys = async (regionCode) => {
    if (!regionCode) {
      dispatch(
        updateGlobalState({
          value: [],
          stateName: ALL_SURVEYS,
        }),
      );
      return;
    }
    const data = await getAllSurveys(regionCode);

    dispatch(
      updateGlobalState({
        value: data,
        stateName: ALL_SURVEYS,
      }),
    );
  };

  const fetchAllProjectUsers = async (projectId) => {
    const allProjectUsers = await getAllProjectUsers(projectId);
    if (allProjectUsers.message !== "No users could be found.") {
      const sortedData = allProjectUsers.sort((a, b) =>
        a.name.localeCompare(b.name),
      );
      dispatch(
        updateGlobalState({
          value: sortedData,
          stateName: ALL_PROJECT_USERS,
        }),
      );
    }
  };

  useEffect(() => {
    fetchRegions();
  }, []);

  return (
    <div className="project-config-page">
      <Container fluid className="project-config-shell">
        <h1 className="project-config-title">Project Setup</h1>
        <Row>
          <Col>
            <label>
              Which region is this project for?
              <MandatoryFieldIndicator />
            </label>
            <div style={{ paddingTop: "8px" }}>
              <Select
                className="acc-project-select project-setup-select"
                classNamePrefix="acc-project-select"
                options={regions
                  .sort((a, b) => a.name.localeCompare(b.name))
                  .map((region) => ({
                    value: region.name,
                    label: region.name,
                    data: region,
                  }))}
                isSearchable={true}
                onChange={(region) => {
                  setProjectInput({
                    ...projectInput,
                    region: region,
                  });
                  fetchRegionAssetFilters(region.data.code);
                }}
                value={projectInput?.region || null}
                isDisabled={!editRights.includes(userDetails?.role)}
              />
            </div>
          </Col>
        </Row>
        {/* Input for Project Code */}
        <Row style={{ paddingTop: "20px" }}>
          <Col>
            <label>
              Project Code
              <MandatoryFieldIndicator />
            </label>
            <div style={{ paddingTop: "8px" }}>
              <input
                type="text"
                className="form-control form-control-sm project-setup-text-input"
                placeholder="Enter Project Code"
                value={projectInput.projectCode || ""}
                onChange={(e) => {
                  setProjectInput((prev) => ({
                    ...prev,
                    projectCode: e.target.value,
                  }));
                }}
                disabled={!editRights.includes(userDetails?.role)}
              />
            </div>
          </Col>
        </Row>

        {/* If selectedRegion Project Location Code then enter the code */}
        {projectInput.region &&
          projectInput.region.data?.projectLocationCode && (
            <Row style={{ paddingTop: "20px" }}>
              <Col>
                <label>
                  Project Location Code
                  <MandatoryFieldIndicator />
                </label>
                <div style={{ paddingTop: "8px" }}>
                  <input
                    type="text"
                    className="form-control form-control-sm project-setup-text-input"
                    placeholder="Enter Project Location Code"
                    value={projectInput.projectLocationCode || ""}
                    onChange={(e) => {
                      setProjectInput((prev) => ({
                        ...prev,
                        projectLocationCode: e.target.value,
                      }));
                    }}
                    disabled={!editRights.includes(userDetails?.role)}
                  />
                </div>
              </Col>
            </Row>
          )}

        {/* Asset Filtering */}
        {assetFilterLevels?.map((level, i) => (
          <Row style={{ paddingTop: "20px" }} key={level + i}>
            <Col>
              <label>
                {level}
                <MandatoryFieldIndicator />
              </label>
              <div style={{ paddingTop: "8px" }}>
                <Select
                  className="acc-project-select project-setup-select"
                  classNamePrefix="acc-project-select"
                  options={assetFilters
                    .sort((a, b) => a.name.localeCompare(b.name))
                    .filter((f) => f.level === level)
                    .map((filter) => ({
                      value: filter.code,
                      label: filter.name,
                      data: filter,
                    }))}
                  value={
                    projectInput?.assetFilters?.[
                      level
                        .replace(/\s+/g, "")
                        .replace(/^[A-Z]/, (m) => m.toLowerCase())
                    ] || null
                  }
                  onChange={(filter) => {
                    fetchRegionAssetFilters(
                      null,
                      filter.data.id,
                      filter.data.levelIndex,
                    );
                    let levelCamelCase = level
                      .replace(/\s+/g, "")
                      .replace(/^[A-Z]/, (m) => m.toLowerCase());
                    const tempAssetFilters = {
                      ...projectInput?.assetFilters,
                      [levelCamelCase]: filter,
                    };

                    let tempObjectInput = {};
                    Object.keys(tempAssetFilters).forEach((key) => {
                      if (
                        tempAssetFilters[key].data.levelIndex <=
                        filter.data.levelIndex
                      ) {
                        tempObjectInput[key] = tempAssetFilters[key];
                      }
                    });
                    setProjectInput({
                      ...projectInput,
                      assetFilters: tempObjectInput,
                    });
                  }}
                  isSearchable={true}
                  isDisabled={!editRights.includes(userDetails?.role)}
                />
              </div>
            </Col>
          </Row>
        ))}

        {/* Button to save the project */}
        <Row style={{ paddingTop: "20px" }}>
          <Col>
            <div style={{ display: "flex", justifyContent: "flex-start" }}>
              <button
                className="btn btn-sm project-config-action-btn mwh-btn-success"
                onClick={() => {
                  saveProjectSetup();
                  // Add logic to save the project input data
                }}
                disabled={!editRights.includes(userDetails?.role)}
              >
                Save Project Setup
              </button>
            </div>
          </Col>
        </Row>
        <MandatoryExplanation />
      </Container>
    </div>
  );
};

export default ProjectSetupNew;
